export const oracleDecimals = 8;

export const minMarginDecimals = 4;
